module.exports = __webpack_public_path__ + "img/TUR-A-2-I.e9a1808d.png";